/**
* Copyright Aquera Inc 2025
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * SideBarPanel CSS
 */
export const styles = css`
	:host {
		width: 100%; 
		height: 100%;
		overflow-y: auto;
	}

`;

export default [styles];